var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":_vm.round.preview}})])
}
var staticRenderFns = []

export { render, staticRenderFns }